const PersonContact = element => {
  const elements = {
    self: element,
    toggleForm: element.querySelector('[data-js-element="o-person-contact__button"]'),
    closeForm: element.querySelector('[data-js-element="o-person-contact__button-close"]')
  };

  const state = {
    formIsOpen: false
  };

  const formIsOpenClass = 'o-person-contact--form-is-open';

  const toggleForm = () => {
    if (!state.formIsOpen) {
      elements.self.classList.add(formIsOpenClass);
      state.formIsOpen = true;
    } else {
      elements.self.classList.remove(formIsOpenClass);
      state.formIsOpen = false;
    }
  };

  elements.toggleForm.addEventListener('click', toggleForm);
  elements.closeForm.addEventListener('click', toggleForm);
};

export default PersonContact;
